// extracted by mini-css-extract-plugin
export default {"base":"-cm_23809cdd","orange":"-cm_6618900c","spin":"-cm_3f563132","faSpin":"-cm_0982e4da"};